/*
 * @Author: fan.li@zuolin.com
 * @Date: 2019-09-26 14:28:46
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-09-27 11:41:38
 *
 * 交易概览设置
 */

const api = {
	sumupEcommerceOrderInformation: '/order/sumupEcommerceOrderInformation', // 交易概览 prmt
};

const routes = {
	'/trade-dashboard': '交易概览'
};

export {
	api,
	routes,
};
